<template>
    <li class="nav-item dropdown" @click="toggleDropDown" v-click-outside="closeDropDown">
        <a class="nav-link"
            href="/cart"
            role="button"
            data-toggle="dropdown-toggle"
            aria-haspopup="true"
            aria-expanded="false"
        >
            <div class="nch--container">
                <i class="ni ni-cart" :style="{color: color.secondary}"></i>
                <span v-if="cartItems > 0" class="nch--badge badge-circle badge-floating"
                    :class="`text-${color.secondary}`"
                >{{cartItems}}</span>
            </div>
        </a>
    </li>
</template>

<script>
export default {
    name: 'Cart',
    data() {
        return {
            isOpen: false
        }
    },
    props: {
        cart: {
            type: Number,
        },
        color: {
            type: Object,
            required: true
        }
    },
    computed: {
        cartItems() {
            return this.$store.getters.CART_ITEMS
        },
    },
    methods: {
        toggleDropDown() {
            this.isOpen = !this.isOpen;
        },
        closeDropDown() {
            this.isOpen = false;
            this.$emit('change', false);
        }
    },
    mounted() {
        this.$store.commit('SET_CART_ITEMS', this.cart)
    }
}
</script>

<style style scoped>
    .nch--container {
        position: relative;
    }
    .nch--badge {
        background-color: #e23d3d;
        top: -10px;
        left: 7px;
        position: absolute;
        width: 18px;
        height: 18px;
        font-size: 0.65rem;
    }
</style>
